import React from 'react';
const withProperProps = (Component, intParse = []) => {
    const getProperOwnProperty = function (Obj, prop) {
        return Object.keys(Obj).reduce((propCS, key) => {
            if (key.toLowerCase() === prop.toLowerCase()) {
                return key;
            } else {
                return propCS;
            }
        }, null);
    };
    let myPropTypes = Component.propTypes;
    return class extends React.Component {
        constructor(props) {
            super(props);
            
            this.state = {properProps:[]};
        }

        static displayName = "withProperProps" + (Component.displayName || Component.name || 'Component');
        
        static getDerivedStateFromProps(props,state) {
            return {
                properProps: Object.keys(props).reduce((acc, propKey, idx) => {
                    let key = getProperOwnProperty(myPropTypes, propKey) || propKey;
                    acc[key] = props[propKey];
                    if (intParse.indexOf(key) >= 0) {
                        acc[key] = parseInt(acc[key]);
                    }
                    return acc;
                }, {})
            }
        }

        render() {
            return <Component
                {...this.state.properProps}
            />;
        }
    }
}
export default withProperProps;